import { render, staticRenderFns } from "./PageProducts.vue?vue&type=template&id=35286a24&scoped=true&"
import script from "./PageProducts.vue?vue&type=script&lang=ts&"
export * from "./PageProducts.vue?vue&type=script&lang=ts&"
import style0 from "./PageProducts.vue?vue&type=style&index=0&id=35286a24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35286a24",
  null
  
)

export default component.exports